import React, { useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import Content from "./Content";
import Header from "./Header";
import RightPanel from "./RightPanel";
import Sider from "./Sider";
import TagsView from "./TagsView";
import { Layout } from "antd";
import { fetchUnreadCount } from "@/store/actions/message";

const Main = (props) => {
  const { tagsView, fetchUnreadCount } = props;
  const location = useLocation();

  // 使用 useCallback 缓存函数，避免不必要的重新创建
  const handleFetchUnreadCount = useCallback(() => {
    // fetchUnreadCount();
  }, [fetchUnreadCount]);

  // 组件挂载和路由变化时获取消息数，并设置定时器
  useEffect(() => {
    // 初始获取
    handleFetchUnreadCount();

    // 创建定时器
    const timer = setInterval(handleFetchUnreadCount, 60000);

    // 组件卸载时清理定时器
    return () => {
      clearInterval(timer);
    };
  }, [location.pathname, handleFetchUnreadCount]); // 添加路由作为依赖

  return ( 
    <Layout style={{ height: "100vh", display: "flex", flexDirection: "row" }}>
      {/* 这个布局是 左边是侧边栏，右边是内容区 */}
      <Sider /> 
      <Layout style={{ flex: 1, display: "flex", flexDirection: "column", overflow: 'hidden' }}>
        <Header />
        {tagsView ? <TagsView /> : null}
        <Layout style={{ flex: 1, overflow: 'auto' }}>
          <Content />
        </Layout>
        {/* <RightPanel /> */}
      </Layout>
    </Layout>
  );
};

const mapStateToProps = (state) => ({
  ...state.settings,
  unreadData: state.message.unreadData  // 添加 unreadData 到 props
});

export default connect(mapStateToProps, { fetchUnreadCount })(Main);
